export const insightReducerName = "insights";
